/* src/app/builder-screen-beta/json-preview/json-preview.component.scss */
.json-preview {
  background: #f7f7f7;
  padding: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  overflow: visible;
  font-family:
    "Monaco",
    "Menlo",
    "Ubuntu Mono",
    monospace;
  font-size: 13px;
  line-height: 1.6;
  min-height: 80px;
  white-space: pre-wrap;
  word-break: break-word;
  transition: all 0.3s ease;
}
.json-preview .json-key {
  color: #0451a5;
  font-weight: 500;
}
.json-preview .json-string {
  color: #0a7c00;
}
.json-preview .json-number {
  color: #098658;
}
.json-preview .json-boolean {
  color: #0000ff;
  font-weight: 500;
}
.json-preview .json-null {
  color: #795e26;
  font-style: italic;
}
.json-preview .json-punctuation {
  color: #000000;
}
.json-preview .json-content {
  white-space: pre-wrap;
  word-break: break-word;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  margin: 0;
  padding: 0;
}
.json-preview:hover {
  border-color: #d9d9d9;
}
.json-preview.error {
  background: #fff2f0;
  border-color: #ffccc7;
  color: #cf1322;
}
[data-theme=dark] .json-preview {
  background: #1f1f1f;
  border-color: #434343;
  color: #ffffff;
}
[data-theme=dark] .json-preview:hover {
  border-color: #595959;
}
[data-theme=dark] .json-preview.error {
  background: #2a1215;
  border-color: #5c2526;
  color: #ff7875;
}
[data-theme=dark] .json-preview .json-key {
  color: #4fc1ff;
}
[data-theme=dark] .json-preview .json-string {
  color: #ce9178;
}
[data-theme=dark] .json-preview .json-number {
  color: #b5cea8;
}
[data-theme=dark] .json-preview .json-boolean {
  color: #569cd6;
}
[data-theme=dark] .json-preview .json-null {
  color: #808080;
}
[data-theme=dark] .json-preview .json-punctuation {
  color: #d4d4d4;
}
.toggle-btn {
  display: flex;
  align-items: center;
  gap: 4px;
}
.toggle-btn:hover {
  background: rgba(24, 144, 255, 0.1);
}
@media (max-width: 768px) {
  .json-preview {
    font-size: 11px;
    padding: 12px;
  }
  .json-preview .json-content {
    word-break: break-all;
  }
}
.json-preview {
  transform: translateZ(0);
  will-change: transform;
  contain: layout style paint;
}
/*# sourceMappingURL=json-preview.component.css.map */
